export default __webpack_public_path__ + "static/media/keyvisual-karlsruhe.99bee30b.jpg";